module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "lupa glyphicon glyphicon-search"
  }), _c('v-autocomplete', {
    attrs: {
      "id": _vm.id,
      "items": _vm.companies,
      "get-label": _vm.getLabel,
      "component-item": _vm.item_company,
      "min-len": 1,
      "keep-open": true,
      "input-attrs": _vm.attrs,
      "auto-select-one-item": false
    },
    on: {
      "update-items": _vm.searchCompanies,
      "item-selected": _vm.selectedCompany
    },
    model: {
      value: (_vm.company),
      callback: function($$v) {
        _vm.company = $$v
      },
      expression: "company"
    }
  }), (_vm.show_no_result_found_message) ? _c('div', {
    staticClass: "no-result-found"
  }, [_vm._v("Não há resultados de empresa para essa busca.")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dd262efc!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/autocomplete/companies.vue
// module id = 1225
// module chunks = 1